import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-textcounter', 'remaining', 'Characters remaining:');
Labels.set(
    'ui-textcounter',
    'invalid',
    'Text length is invalid (max %d characters).'
);
